import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import { formatShorthand } from '../../../../common/utils';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';


const ReviewAssocs = ( { aid, uid, contacts, loans } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ lid, setLid ] = useState( null );

    const formatName = ( cid ) => {
        const c = contacts[cid];
        return ( c ) ? c.firstname + ' ' + c.lastname : null;
    };

    const formatLoanField = ( lid, f ) => {
        const l = loans[lid];
        return ( l ) ? l[f] : null;
    };

    const formatLoanName = ( lid ) => {
        const l = loans[lid];
        return ( l ) ? l.name : null;
    };

    const trash = async ( taid ) => {
        // await remove( { aid: aid, uid: uid, cid: c.details.cid, gid: gid } );
        alert( 'need to trash: ' + taid );
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'task':
                // setModal( <AddGift close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        setExpanded( obj.relationships.length > 0 );
        obj.relationships?.forEach( f => {
            if ( f.lid ) {
                setLid( f.lid );
            }
        } );
    }, [ obj.relationships ] );

    
    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Related To ({obj.relationships.length})</Typography></Col>
                        {/* <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'task' ) }>+ Add</Button></Col> */}
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    { obj.relationships.map( ( a, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                <Col className='p-1'>
                                    <Link to={`/contact/${a.cid}`}>{formatName( a.cid )}</Link>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( a.taid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    {
                        ( lid ) ? (
                            <ListGroup.Item>
                                <Row className='align-items-center pt-4'>
                                    <Col xs='auto' className='tf-sidebar-obj-value'>{formatLoanField( lid, 'status' )}</Col>
                                    <Col>
                                        <Row className='align-items-center'>
                                            <Col xs='auto' className='tf-sidebar-obj-key-date-container'>
                                                <span className='tf-sidebar-obj-key-date'>
                                                    <Link to={`/loan/${lid}`}>{formatLoanName( lid )}</Link>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='tf-sidebar-obj-desc'>
                                                {formatLoanField( lid, 'stage' )} - ${formatShorthand( formatLoanField( lid, 'amount' ) )} - {formatLoanField( lid, 'purpose' )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </ListGroup.Item>
                        ) : (
                            null
                        )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( ReviewAssocs );